import { Badge, Header, Stack } from '@asgard/ui-library';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import * as SP from '../../HrAsAServicePage.styled';
import * as S from './HowIs.styled';

export const HowIs: React.FC = () => {
  const { t } = useI18n('hr-as-a-service');

  const features = [
    {
      title: t('hr-as-a-service.how-is.feature1.title'),
      desc: (
        <HtmlTrans
          ns="hr-as-a-service"
          i18nKey={'hr-as-a-service.how-is.feature1.desc'}
        />
      )
    },

    {
      title: t('hr-as-a-service.how-is.feature2.title'),
      desc: (
        <HtmlTrans
          ns="hr-as-a-service"
          i18nKey={'hr-as-a-service.how-is.feature2.desc'}
        />
      )
    },

    {
      title: t('hr-as-a-service.how-is.feature3.title'),
      desc: (
        <HtmlTrans
          ns="hr-as-a-service"
          i18nKey={'hr-as-a-service.how-is.feature3.desc'}
        />
      )
    }
  ];

  return (
    <S.Root>
      <SP.Container>
        <Stack gap="6xl" direction="column">
          <Stack alignment="center" contentAlign="center" direction="column">
            <Header as="h2" size="5xl" editorial>
              <HtmlTrans
                ns="hr-as-a-service"
                i18nKey={'hr-as-a-service.how-is.title'}
              />
            </Header>
          </Stack>

          <S.Features>
            {features.map(({ title, desc }, index) => (
              <S.Feature key={title}>
                <Header as="h3" size="2xl">
                  <strong>0{index + 1}</strong> {title}
                </Header>

                {desc}
              </S.Feature>
            ))}
          </S.Features>

          <Stack
            alignment="center"
            contentAlign="center"
            direction="row"
            gap="xl"
          >
            <S.Badge>
              <Badge
                variant="hard"
                schema="active"
                bold
                size="s"
                label={t('hr-as-a-service.how-is.badge')}
              />
            </S.Badge>

            <S.BadgeDesc>
              <HtmlTrans
                ns="hr-as-a-service"
                i18nKey={'hr-as-a-service.how-is.badge-desc'}
              />
            </S.BadgeDesc>
          </Stack>
        </Stack>
      </SP.Container>
    </S.Root>
  );
};
